import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppAliasIntlFormatter } from '@/app/hooks/formatFeatureName';
import { useOrder } from '@/app/modules/ECommerce/pages/miniPOS/services/service';
import THEME from '@/app/modules/ECommerce/pages/miniPOS/utils/theme';

export const useMiniPOSParams = () => {
  const { pathname } = useLocation();

  const shopMatch = pathname.match(/\/shop\/([^/]+)/);
  const orderMatch = pathname.match(/\/mini-pos\/order\/([^/]+)/);

  return {
    shopId: shopMatch ? shopMatch[1] : null,
    orderId: orderMatch ? orderMatch[1] : null
  };
};

export const useMiniPOSPaymentParams = () => {
  const { pathname } = useLocation();

  const shopMatch = pathname.match(/\/shop\/([^/]+)/);
  const orderMatch = pathname.match(/\/mini-pos\/payment\/([^/]+)/);

  return {
    shopId: shopMatch ? shopMatch[1] : null,
    orderId: orderMatch ? orderMatch[1] : null
  };
};

export const useMiniPOSOrderDetailParams = () => {
  const { pathname } = useLocation();

  const shopMatch = pathname.match(/\/shop\/([^/]+)/);
  const orderMatch = pathname.match(/\/mini-pos\/order-detail\/([^/]+)/);

  return {
    shopId: shopMatch ? shopMatch[1] : null,
    orderId: orderMatch ? orderMatch[1] : null
  };
};

const SecondAppBar = () => {
  const { shop } = useSelector(state => state.auth);
  const { orderId } = useMiniPOSParams();
  const formatMessage = useAppAliasIntlFormatter();
  const { data: order } = useOrder(orderId);

  return (
    <AppBar
      position="fixed"
      sx={{
        top: '75px',
        // zIndex: theme => theme.zIndex.drawer + 1,
        background: THEME.primary,
        height: 55,
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Toolbar
        sx={{
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingY: 0
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '1.2rem',
            lineHeight: 1.1
          }}
        >
          {shop?.name}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: '#fff',
            opacity: 0.9,
            marginTop: '2px',
            fontSize: '0.85rem'
          }}
        >
          {formatMessage({ id: 'mini.pos.second.appbar.type' })} {' : '}
          {formatMessage({ id: `mini.pos.type.${order?.customerType}.name` })}
          {order?.customerType === 'shop'
            ? formatMessage(
                { id: `mini.pos.second.appbar.table.guest` },
                { table: order.tableNumber, count: order.peopleCount }
              )
            : ''}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default SecondAppBar;
